/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
import React from "react";
import { Icon, SideDrawer } from "../ui";
import { displayName, displayInitial, roleMeta } from "../lib/userDisplay";
import { userStorePinLabel } from "../theme";
import { PAGE_TITLES, hrefForAppPage, shouldHandleAsSpaNav } from "../routing/paths";

export function AppShell({
  user,
  page,
  setPage,
  lang,
  activeTheme,
  isMobileViewport,
  navCollapsed,
  setNavCollapsed,
  drawerOpen,
  setDrawerOpen,
  navItems,
  onLogout,
  onStopImpersonating,
  children,
}) {
  const collapseDesktop = !isMobileViewport && navCollapsed;
  const desktopSidebarWidthPx = collapseDesktop ? 52 : 224;
  const titles = PAGE_TITLES;

  return (
    
        <>
      <div className="app-shell">

        {/* Desktop Sidebar */}
        <aside
          className="sidebar"
          style={
            !isMobileViewport
              ? {
                  width: desktopSidebarWidthPx,
                  transition: "width 0.2s ease",
                }
              : undefined
          }
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              flexDirection: "column",
              flex: 1,
              width: "100%",
              minHeight: "100vh",
              minWidth: 0,
              overflow: !isMobileViewport && collapseDesktop ? "hidden" : undefined,
            }}
          >
            <div
              className="sidebar-logo"
              style={
                collapseDesktop
                  ? { justifyContent: "center", padding: "18px 8px 14px" }
                  : undefined
              }
            >
              <img
                src={activeTheme.logoSrc}
                alt={activeTheme.name}
                style={{ width: 48, height: 48, borderRadius: 12, objectFit: "cover" }}
              />
              {!collapseDesktop && (
                <div>
                  <div className="brand-name">{activeTheme.name}</div>
                  <div className="brand-sub">Operations</div>
                </div>
              )}
            </div>
            {!collapseDesktop && (
              <div className="sidebar-user">
                <div className="sidebar-user-row">
                  <div className="user-avatar">{displayInitial(user)}</div>
                  <div className="sidebar-user-copy">
                    <div className="user-name" title={displayName(user)}>{displayName(user)}</div>
                    <span className="user-role-badge">{lang === "gr" ? roleMeta(user).labelGr : roleMeta(user).label}</span>
                  </div>
                </div>
                <div className="user-store" style={{ marginTop: 8 }}>📍 {userStorePinLabel(user)}</div>
              </div>
            )}
            <nav className="sidebar-nav" style={collapseDesktop ? { padding: "8px 0", alignItems: "center" } : undefined}>
              {navItems.map(item => (
                <a
                  key={item.id}
                  href={hrefForAppPage(item.id)}
                  className={`nav-button ${page === item.id ? "nav-active" : ""}`}
                  style={
                    collapseDesktop
                      ? {
                          position: "relative",
                          width: 52,
                          height: 44,
                          minHeight: 44,
                          padding: 0,
                          justifyContent: "center",
                          gap: 0,
                        }
                      : undefined
                  }
                  title={collapseDesktop ? (lang === "gr" ? item.labelGr : item.label) : undefined}
                  onClick={(e) => {
                    if (!shouldHandleAsSpaNav(e)) return;
                    e.preventDefault();
                    if (item.onClick) item.onClick();
                    else setPage(item.id);
                  }}
                >
                  <Icon name={item.icon} size={17} />
                  {!collapseDesktop && (lang === "gr" ? item.labelGr : item.label)}
                  {!collapseDesktop && item.badge > 0 && <span className="nav-notification">{item.badge}</span>}
                  {collapseDesktop && item.badge > 0 && (
                    <span
                      className="nav-notification"
                      style={{ position: "absolute", top: 4, right: 2, marginLeft: 0 }}
                    >
                      {item.badge}
                    </span>
                  )}
                </a>
              ))}
            </nav>
            <div className="sidebar-bottom" style={collapseDesktop ? { padding: "10px 6px", alignItems: "center" } : undefined}>
              <button
                type="button"
                className="signout-button"
                title={lang === "gr" ? "Αποσύνδεση" : "Sign Out"}
                style={collapseDesktop ? { justifyContent: "center", padding: "10px 8px", gap: 0 } : undefined}
                onClick={onLogout}
              >
                <Icon name="logout" size={15} />
                {!collapseDesktop && (lang === "gr" ? "Αποσύνδεση" : "Sign Out")}
              </button>
            </div>
          </div>
          {!isMobileViewport && (
            <div
              className="nav-collapse-handle"
              role="button"
              tabIndex={0}
              onClick={() => setNavCollapsed((prev) => !prev)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setNavCollapsed((prev) => !prev);
                }
              }}
              title={navCollapsed ? "Expand navigation" : "Collapse navigation"}
              style={{
                position: "absolute",
                right: -12,
                top: "50%",
                transform: "translateY(-50%)",
                width: 20,
                height: 48,
                background: "var(--surface)",
                border: "1.5px solid var(--border)",
                borderLeft: "none",
                borderRadius: "0 8px 8px 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                zIndex: 10,
                boxShadow: "2px 0 8px rgba(0,0,0,0.06)",
              }}
            >
              <span
                className="nav-collapse-chevron"
                style={{ fontSize: 12, fontWeight: 900, color: "var(--text-muted)" }}
                aria-hidden
              >
                {navCollapsed ? "›" : "‹"}
              </span>
            </div>
          )}
        </aside>

        {/* Mobile Drawer */}
        <SideDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          user={user}
          lang={lang}
          activeTheme={activeTheme}
          navItems={navItems}
          page={page}
          setPage={setPage}
          onLogout={() => { onLogout(); setDrawerOpen(false); }}
        />

        {/* Mobile Top Header */}
        <div className="mobile-header">
          <div className="mobile-logo">
            <img
              src={activeTheme.logoSrc}
              alt={activeTheme.name}
              style={{ width: 48, height: 48, borderRadius: 12, objectFit: "cover" }}
            />
            <div>
              <div className="mobile-brand">{activeTheme.name}</div>
              <div className="mobile-page-title">{titles[page]?.[lang]}</div>
            </div>
          </div>
          <div className="mobile-header-right">
            <button
              type="button"
              className="btn-base btn-outline btn-small"
              style={{ padding: "8px 10px" }}
              aria-label={lang === "gr" ? "Μενού" : "Menu"}
              aria-expanded={drawerOpen}
              onClick={() => setDrawerOpen(true)}
            >
              <Icon name="menu" size={18} />
            </button>
          </div>
        </div>

        {/* Main Content */}
        <main
          className="main-area"
          style={
            !isMobileViewport
              ? {
                  marginLeft: desktopSidebarWidthPx,
                  transition: "margin-left 0.2s ease",
                }
              : undefined
          }
        >
          {user?.impersonated && (
            <div
              role="status"
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 8,
                padding: "8px 16px",
                background: "rgba(245, 158, 11, 0.16)",
                borderBottom: "1px solid #F59E0B",
                fontSize: 13,
                color: "var(--text-primary)",
              }}
            >
              <span>
                {lang === "gr" ? "Προβολή ως" : "Viewing as"}{" "}
                <strong>{user.email}</strong>
                {user.impersonator_email
                  ? ` · ${lang === "gr" ? "συνδεδεμένος ως" : "signed in as"} ${user.impersonator_email}`
                  : ""}
              </span>
              <button type="button" className="btn-base btn-outline btn-small" onClick={onStopImpersonating}>
                {lang === "gr" ? "Τέλος προβολής" : "Stop viewing as"}
              </button>
            </div>
          )}
          {page !== "builder" && (
            <div className="topbar">
              <h1 className="page-heading">{titles[page]?.[lang]}</h1>
              <div className="topbar-end" id="app-topbar-end" />
            </div>
          )}
          <div
            className={
              page === "builder"
                ? "page-content page-content--schedule-builder"
                : page === "hr-dashboard"
                  ? "page-content page-content--hr-dashboard"
                  : "page-content"
            }
          >
            {children}
          </div>
        </main>

      </div>
    </>
  );
}
